import { resolveStepStatusBadge } from '../../utils/stepStatusBadge';
import styles from '../../styles/automationStudio.module.scss';

const TONE_CLASS = {
    success: styles.statusBadgeSuccess,
    failed: styles.statusBadgeFailed,
    running: styles.statusBadgeRunning,
    pending: styles.statusBadgePending,
    skipped: styles.statusBadgeSkipped,
};

/**
 * Presentational execution status chip — preserves caller label text; only styles by tone.
 */
export default function StepStatusChip({
    status,
    label,
    uppercase = false,
    className = '',
}) {
    const { tone, spinner } = resolveStepStatusBadge(status);
    const toneClass = TONE_CLASS[tone] ?? TONE_CLASS.pending;
    const displayLabel = label ?? status ?? 'pending';

    return (
        <span
            className={[
                styles.statusBadge,
                toneClass,
                uppercase ? styles.statusBadgeUppercase : '',
                className,
            ].filter(Boolean).join(' ')}
            role="status"
            aria-label={`Step status: ${displayLabel}`}
        >
            {spinner ? (
                <span className={`${styles.statusBadgeSpinner} ${styles.asSpinner} ${styles.asSpinnerSm}`} aria-hidden />
            ) : (
                <span className={styles.statusBadgeDot} aria-hidden />
            )}
            {displayLabel}
        </span>
    );
}
